<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
	<modal-header-default></modal-header-default>
	<div class="bp-modal-body-section text-center">
		<svg-inline [src]="'/assets/images/new-deposit-now-icon.svg'" [alt]="'verify_alt_text'" />
		<div class="main-headline">{{ "trade_make_deposit" | translate }}</div>
		<div>{{ "trade_fund_account" | translate }}</div>
		<button (click)="onClick()" class="btn btn-primary">{{ "deposit_tx_item" | translate }}</button>
	</div>
</div>
